var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.syncWarnings');
    };
  };
};

export default createGetFormSyncWarnings;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/getFormSyncWarnings.js
// module id = 1221
// module chunks = 0